enum NavigationListAction {
    Up,
    Down,
    Click,
    None
}

export default NavigationListAction;
